//require('core-js');

var $ = require('jquery');
window.$ = $;
window.jQuery = $;

require('materialize-css/dist/js/materialize.js');
require('../../vendor/artofwhere/aow-lib/resources/frontend-lib/jquery.html5uploader.min.js'); //Only used by PhotoLab

require('../../vendor/artofwhere/aow-lib/resources/js/AOW.js');

require('./ProductDesignView.js');
require('./routes.js');
require('./account/SocialApp.js');


require('./create/Product.js');

var req = require.context("./create/ProductCategories", true, /^(.*\.(js$))[^.]*$/im);
req.keys().forEach(function(key){
    req(key);
});

//Parent products first, prefixed by _
var req = require.context("./create/Products", true, /^(.*\/_[a-zA-Z0-9]+\.(js$))[^.]*$/im);
req.keys().forEach(function(key){
    req(key);
});

var req = require.context("./create/Products", true, /^(.*\/[a-zA-Z0-9]+\.(js$))[^.]*$/im);
req.keys().forEach(function(key){
    req(key);
});

require('./info/Dropship.js');
require('./info/Help.js');
require('./info/ProductionAndShipping.js');
require('./info/Fabrics.js');
require('./ShippingTables.js');
